<template>
  <v-row justify="end" class="mr-0">
    <v-dialog persistent v-model="addItemDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{$t(translation+'.add')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-on:submit.prevent>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    type="number"
                    v-model="form.id"
                    :label="$t(translation+'.id')+'*'" required
                    :rules="rules.required"
                    autocomplete="off"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.name"
                    :label="$t(translation+'.name')+'*'" required
                    :rules="rules.required_length"
                    autocomplete="off"
                  />
                </v-col>
                <v-col cols="6">
                  <v-combobox
                    v-model="city"
                    :items="cities"
                    @change="form.city_id = city.id"
                    :label="$t(translation+'.city')+'*'" required
                    item-text="name"
                    autocomplete="off"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.phone"
                    :label="$t(translation+'.phone')"
                    autocomplete="off"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.bonus"
                    :label="$t(translation+'.bonus')+'*'" required
                    :rules="rules.requiredField"
                    autocomplete="off"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.debt"
                    :label="$t(translation+'.debt')+'*'" required
                    :rules="rules.requiredField"
                    autocomplete="off"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.payment"
                    :label="$t(translation+'.payment')+'*'" required
                    :rules="rules.requiredField"
                    autocomplete="off"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.toolCash"
                    :label="$t(translation+'.toolCash')+'*'" required
                    :rules="rules.requiredField"
                    autocomplete="off"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.annualPlan"
                    :label="$t(translation+'.annualPlan')+'*'" required
                    :rules="rules.requiredField"
                    autocomplete="off"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.moneyCirculation"
                    :label="$t(translation+'.moneyCirculation')+'*'" required
                    :rules="rules.requiredField"
                    autocomplete="off"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.password"
                    :label="$t(translation+'.password')+'*'"
                    type="password"
                    required
                    :rules="rules.required_password_length"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.confirmPassword"
                    :label="$t(translation+'.password_again')+'*'"
                    type="password"
                    required
                    :rules="rules.password_match"
                  />
                </v-col>
                <v-col cols="12">
                  <v-combobox readonly @click="openChooseCategoryDialog" item-text="name" multiple
                              :label="$t(translation+'.categories')" v-model="form.categories"/>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>{{$t('required_fields')}}</small>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text :disabled="loading" @click="closeDialog">{{$t('close')}}</v-btn>
          <v-btn color="blue darken-1" text :loading="loading" @click="check">{{$t('add')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!---------------------------------- Snackbar  ----------------------------------------->
    <v-snackbar
      v-model="snackbar.show"
      :bottom=true
      :color="snackbar.color"
      :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn dark text @click="snackbar.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <choose-categories
      :selectedItems="form.categories"
      :chooseCategoryDialog="chooseCategoryDialog"
      :campaign="false"
      @close="chooseCategoryDialog=false"
      @editEmit="editEmit"/>
  </v-row>
</template>

<script>
  import {add, readCities} from "../../statics/DataTableFunctions";
  import ChooseCategories from "../campaigns/ChooseCategories";
  import ChooseCategory from "../categories/ChooseCategory";

  export default {
    props: {
      addItemDialog: false,
    },
    name: "AddPartner",
    components: {
      'choose-categories': ChooseCategory
    },
    data() {
      return {
        translation: 'partners',
        api: 'partners',
        loading: false,
        cities: [],
        chooseCategoryDialog: false,
        chooseCategoryDialogData: [],
        city: '',
        form: {
          id: '',
          categories: [],
          name: '',
          city_id: null,
          phone: '',
          bonus: '',
          debt: '',
          toolCash: '',
          payment: '',
          annualPlan: '',
          moneyCirculation: '',
          password: '',
          confirmPassword: '',
        },
        rules: {
          required: [
            v => v != null || this.$t('validation.field'),
          ],
          required_length: [
            v => !!v || this.$t('validation.field'),
            v => v === '' || v.length > 1 || this.$t(this.translation + '.validation')
          ],
          requiredField: [
            v => !!v || this.$t('validation.field'),
            v => +v >= 0 || this.$t(this.translation + '.partnerNumber'),
          ],
          required_password_length: [
            v => !!v || this.$t('validation.field'),
            v => this.form.password != undefined && this.form.password.length >= 4 || this.$t('short_password')
          ],
          password_match: [
            v => !!v || this.$t('validation.field'),
            v => v === this.form.password || this.$t('validation.password_match')
          ],
        },
        snackbar: {
          color: 'success',
          show: false,
          text: '',
          timeout: 3000,
        },
      }
    },
    methods: {
      editEmit(data){
        this.form.categories = data;
      },
      check(){
        if(this.form.categories.length === 0){
          this.$swal.fire({
            type: 'error',
            title: this.$t('validation.error'),
            text: this.$t('validation.categoryCountException'),
          });
          return;
        }
        this.add(this.api);
      },
      closeChooseCategoryDialog() {
        this.chooseCategoryDialog = false;
      },
      openChooseCategoryDialog() {
        this.chooseCategoryDialog = true;
        this.chooseCategoryDialogData = this.form.categories;
      },
      chooseCategoryEmit(data) {
        this.form.categories = data;
        this.chooseCategoryDialog = false;
      },
      add,
      readCities,
      closeDialog() {
        this.city = '';
        this.form = {
          id: '',
          categories: [],
          name: '',
          city_id: null,
          phone: '',
          bonus: '',
          toolCash: '',
          debt: '',
          payment: '',
          annualPlan: '',
          moneyCirculation: '',
          password: '',
          confirmPassword: '',
        }
        this.$refs.form.resetValidation()
        this.$emit('close')
      },
    },
    created() {
      this.readCities();
    },
  }
</script>

<style scoped/>
